import { Collapse, Row, Tag, Tooltip, Card } from 'antd';
import classnames from 'classnames';

import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import createChoiceItemByType, { ChoicePanelProps } from './createChoiceItemByType';

const { Panel } = Collapse;

const ChoicePanel = (props: ChoicePanelProps): JSX.Element => {
  const { choiceId, choice, preference } = props;
  const [open, setOpen] = useState<string>();
  const isRequiredAndNotProvided =
    choice.required &&
    (typeof preference === 'undefined' || (Array.isArray(preference) && preference.length === 0));

  useEffect(() => {
    if (isRequiredAndNotProvided) {
      setOpen(choiceId);
    }
  }, [isRequiredAndNotProvided, choiceId]);

  const choiceItemResult = createChoiceItemByType(props);

  if (!choiceItemResult) {
    return <></>;
  }
  const { title, configureField } = choiceItemResult;

  return (
    <Row
      justify="start"
      gutter={[32, 32]}
      style={{
        marginLeft: 10 * props.levelNested,
        ...(props.levelNested === 0
          ? {
              border: '1px solid #d9d9d9',
              boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.1)',
              borderRadius: 5,
              padding: 10,
              backgroundColor: '#f5f5f5',
            }
          : {
              backgroundColor: 'white',
              padding: 10,
            }),
      }}
    >
      <Collapse
        activeKey={open}
        ghost
        style={{ textAlign: 'left' }}
        onChange={() => {
          if (!isRequiredAndNotProvided) {
            setOpen(open === choiceId ? undefined : choiceId);
          }
        }}
      >
        <Panel
          header={
            <Tooltip
              placement="topLeft"
              title={
                choice.type === 'manual'
                  ? `Edit how this field should look by double clicking the tags, or by adding extra data`
                  : 'Update by expanding this, and selecting the choice you prefer'
              }
            >
              <span style={{ marginRight: 10 }}>{`${choice.label}`}</span>
              {isRequiredAndNotProvided && !title && !preference && <Tag color="red">Required</Tag>}
              {title && <Tag color="green">{title}</Tag>}
            </Tooltip>
          }
          key={choiceId}
          className={classnames(isRequiredAndNotProvided && styles.requiredPanel)}
        >
          {configureField}
          {props.prerequisiteChoicePanels.length > 0 ? (
            <Card title={'Only run when following conditions are met'}>
              {props.prerequisiteChoicePanels}
            </Card>
          ) : undefined}
          {props.dependencyChoicePanels.length > 0 ? (
            <Card title={'Related choices'}>{props.dependencyChoicePanels}</Card>
          ) : undefined}
        </Panel>
      </Collapse>
    </Row>
  );
};

export default ChoicePanel;
